import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notifications } from '@mantine/notifications';
import { useTranslation } from 'react-i18next';
import { AlertApi } from '../../../apis/AlertApi/AlertApi';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { AppMedError } from '../../../error/AppMedError';

export interface ISendAlertToAssistantVariables {
    id: number;
    language: string;
}

export function useSendAlertToAssistant() {
    const queryClient = useQueryClient();
    const { t } = useTranslation();

    return useMutation<{ assistantName: string; assistantEmail: string }, AppMedError, ISendAlertToAssistantVariables>({
        mutationKey: [QueryKeys.alerts, 'sendToAssistant'],
        mutationFn: async ({ id, language }: ISendAlertToAssistantVariables) => {
            return await AlertApi.sendToAssistant(id, language);
        },
        onSuccess: (data, variables) => {
            queryClient.invalidateQueries({ queryKey: [QueryKeys.alertDetail, variables.id] });
            notifications.show({
                title: t('notification.success'),
                message: t('alert.assistant.sent', { name: data.assistantName }),
                color: 'green',
            });
        },
        onError: (error: AppMedError) => {
            notifications.show({
                title: t('notification.error'),
                message: error?.message || t('notification.error'),
                color: 'red',
            });
        },
    });
}
